import request from '@/utils/request'

/** 门店员工列表（健康师等） */
export function getStoreUserList(data) {
  return request({
    url: '/api/Extend/User',
    method: 'get',
    data
  })
}
